export default __webpack_public_path__ + "static/GRID2022 Stock Disasters RGBlight - Simplify-01-sp-19ec329190568d362297af42be43087e.svg";